import { NpsSurveyScreen } from "@/interactors/NpsSurveyScreen";

export default function NpsSurvey() {
  return <NpsSurveyScreen />;
}
